<template>
    <v-row
        no-gutters
        class="pl-9 pt-10"
    >
        <v-col
            cols="8"
            class="pr-10"
            style="word-break: normal"
        >
            <v-row no-gutters>
                <v-col v-html="$t('billing_app_overview_text')"> <!-- INPUT FROM STATIC TRANSLATION -->
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="4">
            <AppStoreDialogSidebar />
        </v-col>
    </v-row>
</template>

<script>

import PrimaryButton from "@/components/Buttons/PrimaryButton";
import AppStoreDialogSidebar from "@/components/AppStore/AppStoreDialogSidebar";
import AppModule from "@/store/modules/app";

export default {
    name: "BillingDialogOverviewTab",
    components: {
        AppStoreDialogSidebar
    }
};
</script>